import './index.sass';
import axios from 'axios';
import { loadNew } from '~/blocks/grid';
import {handleLikeCard} from "../../blocks/card";
import { data } from 'jquery';

class Illustrations {
  constructor($root) {
    this.$root = $root;
    this.initListeners();
  }

  initAjax($el) {
    if(!$el.attr('data-url')) $el.hide();
    this.$root.find('.js-grid-container').append('<div class="list-loader list-loader--grid"></div>');
    axios.get($el.attr('data-url')).then((response) => {
      const resp = response.data;
      const $illustrations = $(resp.illustrations);
      this.$root.find('.js-grid-container').append($illustrations);
      $illustrations.addClass('grid-hidden');
      if(resp.pagination){
        $('.pagination').replaceWith(resp.pagination);
      }
      loadNew($illustrations);
      handleLikeCard();
      if(!resp.last_page) $el.attr('data-url', resp.url);
      if(resp.last_page) $el.removeAttr('data-url');
    }).catch((error) => {
      console.log(error.response)
    });
  }

  initListeners() {
    const that = this;
    this.$root.find('.js-show-more').on('click', function (e) {
      e.preventDefault();
      that.initAjax($(this));
    });
    this.$root.find('.js-tabs-filter').on('click', (e) => {
      that.$root.find('.js-tab-filter').toggleClass('hidden');
    });
    this.$root.find('.js-aside-filters').on('change', function (e) {
      $(this).val(e.target.value)
      $(this).closest('comment-form').submit()
    })

    this.$root.find('[data-filter]').on('click', function () {
      that.$root.find('#filter').val($(this).data('filter'));
      $(this).closest('form').submit()
    });
  }
}

export default Illustrations;
